import axios from "axios";
import env from "../variables/EndpointEnvironment";
const headers = {
  "Content-Language": localStorage.getItem('i18nextLng'),
}

const TransactionServiceAPI = () => {
  return axios.get(`${env.HOST}/layanan-transaksi`, {
    headers,
  });
};

export default TransactionServiceAPI;
